var backdrop = '_1kdzox97';
var contents = '_1kdzox98';
var contentsHeightVar = '--fpl-contents-height';
var contentsMaxHeightVar = '--fpl-contents-max-height';
var contentsMaxWidthVar = '--_1kdzox91';
var fullscreenRoot = '_1kdzox9h';
var heightVhVar = '--_1kdzox93';
var insetHeight = '_1kdzox9g';
var insetWidth = '_1kdzox9d';
var insetXVar = '--_1kdzox94';
var insetYVar = '--_1kdzox95';
var modalWidthVar = '--_1kdzox90';
var root = '_1kdzox96';
var size = {sm:'_1kdzox99',md:'_1kdzox9a',lg:'_1kdzox9b'};
var topAligned = '_1kdzox9e';
var vhHeight = '_1kdzox9f';
var vwWidth = '_1kdzox9c';
var widthVwVar = '--_1kdzox92';

export { backdrop, contents, contentsHeightVar, contentsMaxHeightVar, contentsMaxWidthVar, fullscreenRoot, heightVhVar, insetHeight, insetWidth, insetXVar, insetYVar, modalWidthVar, root, size, topAligned, vhHeight, vwWidth, widthVwVar };
//# sourceMappingURL=modal.css.js.map
